import B2BConnect from './B2BConnect';

export default B2BConnect;
